import React from "react";

import { DynamicForm } from "src/components/Form";

import { contactFields } from "./fields";

const fields = ({ t }) => [
  ...contactFields({ t, includeAccountNumber: false }),
  {
    key: "url",
    label: t("forms.scholarship.url"),
    required: true,
  },
  {
    key: "major",
    label: t("forms.scholarship.major"),
    required: true,
  },
];

const ScholarshipForm = ({ moduleKey }) => (
  <DynamicForm
    formKey={moduleKey}
    fields={fields}
    defaultSuccessMessageKey="forms.defaultSuccessMessage"
  />
);

export default ScholarshipForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/ScholarshipForm.js